<template>
  <div class="ccui-multifunctional-table-wrapper">
    <el-table
      ref="multipleTable"
      :data="roleSettingList"
      max-height="9999"
      lazy
      border
      class="multifunctional-table"
    >
      <el-table-column type="index" width="50" label="序号"> </el-table-column>

      <template v-for="(table, index) in tableThead">
        <el-table-column
          :key="index"
          :show-overflow-tooltip="true"
          :prop="table.prop"
          :label="table.label"
          :width="table.width"
          :fixed="table.fixed"
        >
          <!--          <template #default="myScope">-->
          <!--                                        <span>{{-->
          <!--                                            formatIsEnable(myScope.row, table)-->
          <!--                                          }}</span>-->
          <!--          </template>-->
        </el-table-column>
      </template>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="{ row }">
          <!--          slot-scope="{ row }"-->
          <el-switch
            v-model="row.isDelte2"
            width="50"
            @change="changeFlag(row)"
          >
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { qryRole, getAppUser, delRole } from "../api/item-list";
export default {
  name: "roleSetting",
  data() {
    return {
      roleSettingList: [],
      objData: ["平台预置角色", "应用预置角色", "", "应用自定义角色"],
      userId: "",
      tableThead: [
        {
          label: "角色类别",
          prop: "roleType2",
          width: "150",
          fixed: false
        },
        {
          label: "角色名称",
          prop: "roleName",
          width: "160",
          fixed: false
        },
        {
          label: "角色描述",
          prop: "description",
          fixed: false
        }
      ]
    };
  },
  mounted() {
    this.getAppUser();
  },
  methods: {
    // 按钮，打开/关闭
    changeFlag(value) {
      this.$emit("getSubmit");
      console.log(value);
      let appName = JSON.parse(localStorage.userInfo).agentName;
      delRole({
        selectUserId: this.userId,
        roleName: value.roleName,
        isDelete: value.isDelte2 ? 0 : 1,
        roleId: value.roleId,
        appName
      }).then(res => {
        console.log(res.data.data);
        this.getAppUser();
      });
    },
    // 详情用户信息
    getAppUser() {
      getAppUser({ id: this.$route.params.roleId }).then(res => {
        if (res.data.code === "0") {
          this.userId = res.data.data.userId;
          qryRole({ selectUserId: this.userId }).then(res => {
            console.log(res.data.data);
            this.roleSettingList = res.data.data;
            this.roleSettingList.map(item => {
              item.isDelte2 = item.isSelect === 0;
              item.roleType2 = this.objData[item.roleType];
            });
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-switch__core {
  height: 24px;
}
/deep/.el-switch__core:after {
  width: 20px;
  height: 20px;
  margin-top: -10px;
}
/deep/.el-switch.is-checked .el-switch__core::after {
  margin-left: -20px;
}
</style>
